ui-cms-cd-contact-channels-footer {
  display: block;

  p {
    margin: 0;
  }

  .contactbox {
    &__item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 1.5;
      padding-bottom: 1.5rem;

      &:last-child {
        padding-bottom: 14px;

        @include breakpoint($medium) {
          padding-bottom: 24px;
        }
      }
    }

    &__icon {
      margin-right: 1rem;
      min-width: 2rem;
      width: 2rem;
      height: 2rem;
    }
  }

  .nowrap {
    white-space: nowrap;
  }
}
